<template>
  <div>
    <b-modal
      v-model="showModal"
      ref="modalError"
      hide-header
      hide-footer
      centered
      @hidden="hide"
    >
      <!-- <div class="modal-header">
        <button type="button" aria-label="Close" class="close" @click="hide">
          ×
        </button>
      </div> -->
      <div class="text-center">
        <font-awesome-icon icon="times-circle" size="5x" class="mb-4" />
      </div>
      <div class="text-center mb-4">
        <p class="text-text" v-if="text">{{ text }}</p>
      </div>
      <div class="border-top p-3 text-center btn-confirm-popup bg-black">
        <div @click="hide">ปิด</div>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      required: false,
      type: String
    }
  },
  data() {
    return {
      showModal: false
    };
  },
  methods: {
    show() {
      this.showModal = true;
      this.$emit("show");
    },
    hide() {
      this.showModal = false;
      this.$emit("hide");
    }
  }
};
</script>

<style rel="scss" scoped>
.modal-header {
  border: 0 !important;
  padding: 0;
}
.text-text {
  font-family: "Kanit-Medium" !important;
  color: #16274a;
  margin-bottom: 0;
  font-size: 20px;
}
.modal-body {
  margin: auto;
  text-align: center;
}
@media (max-width: 767.98px) {
  .text-text {
    font-size: 15px;
  }
}
.bg-black{
  background-color: #000;
  color: #fff;
}
</style>
